import React from 'react';
import {connect} from "react-redux";
import * as vesselActions from "../../actions/vessel";
import l10n from "../../l10n/localization";
import Loader from "../common/Loader";
import validation from '../../validation/vessel';
import Validate from 'validate.js';
import * as utilsCommon from "../../utils/utils";
import CWForm from "./CWForm";

class VesselForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: utilsCommon.notNullNorUndefined(this.props.item) ? this.props.item.item : null,
            schema: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        title: l10n.vessel.name,
                    },
                    year: {
                        type: "number",
                        title: l10n.vessel.year,
                    },
                    oldName: {
                        type: "string",
                        title: l10n.vessel.oldName,
                    },
                }
            },
            uiSchema: {
                name: {
                    "ui:emptyValue": ""
                },
                year: {
                    "ui:emptyValue": "",
                    "ui:widget": "updown",
                },
                oldName: {
                    "ui:emptyValue": ""
                },
            },
            isDirty: false,
            formData: utilsCommon.notNullNorUndefined(this.props.item) ? this.props.item.item : null
        }
    }

    onSubmit = ({formData}) => {
        let form = Object.assign({}, {...formData});

        if (utilsCommon.notNullNorUndefined(this.state.item) && (utilsCommon.notNullNorUndefined(this.state.item.id) || utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement)) {
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    form.id = this.props.newlyCreatedElement;
                    this.props.dispatch(vesselActions.edit(form));
                })
            } else {
                this.setState({item: formData}, () => {
                    this.props.dispatch(vesselActions.edit(form));
                })
            }
        } else {
            this.setState({item: formData}, () => {
                this.props.dispatch(vesselActions.add(form));
            })
        }
        this.setState((state) => {return {...state, isDirty: false,formData: formData};});
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    handleChange = (formData) => {
        let nextState = this.state;

        if(!this.state.isDirty) {
            nextState.isDirty = true;
        }
        nextState.formData = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    handleError = () => {
        this.props.dispatch(vesselActions.errorMessage(l10n.validation.form_error));
    };

    render() {
        if (this.props.loading || this.props.saving) {
            return (<div><Loader /></div>)
        }

        let formClassName = (this.state.isDirty) ? 'vessel-form dirty':'vessel-form';

        return (
            <div className={formClassName}>
                <h1>Vessel</h1>
                <CWForm
                    schema={this.state.schema}
                    uiSchema={this.state.uiSchema}
                    formData={this.state.formData}
                    showErrorList={false}
                    validate={this.validate}
                    liveValidate={true}
                    onError={this.handleError}
                    onChange={({formData})=> {this.handleChange({formData})}}
                    onSubmit={this.onSubmit}>
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                    </div>
                </CWForm>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.vessel.loading,
        saving: state.vessel.saving,

        newlyCreatedElement: state.creation.newlyCreatedVessel,
    });
})(VesselForm);



// WEBPACK FOOTER //
// ./src/components/forms/VesselForm.js